module.exports = __webpack_public_path__ + "static/media/arrowUp_default.79b5653f.svg";